/* global axios */
import React, { useState, useEffect } from 'react';
import api from '../services/apiService';
import { Helmet } from 'react-helmet';

// Optional: feste Optionen – du kannst sie auch dynamisch laden
const UVV_TEMPLATE_TYPE_OPTIONS = [
  { value: 'hubarbeitsbuehne', label: 'Hubarbeitsbühne' },
  { value: 'flurforderzeug', label: 'Flurförderzeug' },
  // weitere Typen später...
];
const UVV_STANDARD_CODE_OPTIONS = [
  { value: 'DGUV 308-002', label: 'DGUV 308-002' },
  { value: 'FEM 4.004', label: 'FEM 4.004' },
  // weitere Normen später...
];

const ProductGroupList = () => {
  const [productGroups, setProductGroups] = useState([]);

  // States für neues Item
  const [newName, setNewName] = useState("");
  const [newCategoryId, setNewCategoryId] = useState("");
  const [newProductGroupId, setNewProductGroupId] = useState("");
  const [newSortOrder, setNewSortOrder] = useState('');
  const [newColor, setNewColor] = useState("");

  // 🔹 NEU: UVV Felder (Create)
  const [newUvvTemplateType, setNewUvvTemplateType] = useState(""); // string
  const [newUvvStandardCode, setNewUvvStandardCode] = useState(""); // string

  // States für den Bearbeitungsmodus
  const [editingGroupId, setEditingGroupId] = useState(null);
  const [editedName, setEditedName] = useState("");
  const [editedCategoryId, setEditedCategoryId] = useState("");
  const [editedProductGroupId, setEditedProductGroupId] = useState("");
  const [editedSortOrder, setEditedSortOrder] = useState("");
  const [editedColor, setEditedColor] = useState("");

  // 🔹 NEU: UVV Felder (Edit)
  const [editedUvvTemplateType, setEditedUvvTemplateType] = useState("");
  const [editedUvvStandardCode, setEditedUvvStandardCode] = useState("");

  // Laden & Sortieren
  const fetchProductGroups = async () => {
    try {
      const response = await api.get('/product-groups');
      const sorted = response.data.sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));
      setProductGroups(sorted);
    } catch (error) {
      console.error("Fehler beim Laden der Produktgruppen:", error);
    }
  };

  useEffect(() => {
    fetchProductGroups();
  }, []);

  // Hinzufügen
  const handleAddGroup = async () => {
    if (!newName.trim()) {
      alert("Bitte gib einen gültigen Namen ein.");
      return;
    }

    try {
      await api.post('/product-groups', {
        name: newName.trim(),
        srrCategoryId: newCategoryId !== "" ? parseInt(newCategoryId, 10) : null,
        srrProductGroupId: newProductGroupId !== "" ? parseInt(newProductGroupId, 10) : null,
        sortOrder: newSortOrder ? parseInt(newSortOrder, 10) : 0,
        color: newColor || null,
        // 🔹 NEU: UVV Felder
        uvvTemplateType: newUvvTemplateType || null,
        uvvStandardCode: newUvvStandardCode || null,
      });

      setNewName("");
      setNewCategoryId("");
      setNewProductGroupId("");
      setNewSortOrder("");
      setNewColor("");
      setNewUvvTemplateType("");
      setNewUvvStandardCode("");

      fetchProductGroups();
    } catch (error) {
      console.error("Fehler beim Hinzufügen der Produktgruppe:", error.response?.data || error.message);
      alert("Fehler beim Hinzufügen: " + (error.response?.data?.details || error.message));
    }
  };

  // Löschen
  const handleDeleteGroup = async (id) => {
    try {
      await api.delete(`/product-groups/${id}`);
      setProductGroups(productGroups.filter(g => g.id !== id));
    } catch (error) {
      console.error("Fehler beim Löschen der Produktgruppe:", error);
      alert("Fehler beim Löschen: " + (error.response?.data?.error || error.message));
    }
  };

  // Wechsel in Bearbeiten
  const handleEditGroup = (group) => {
    setEditingGroupId(group.id);
    setEditedName(group.name);
    setEditedCategoryId(group.srrCategoryId || "");
    setEditedProductGroupId(group.srrProductGroupId || "");
    setEditedSortOrder(group.sortOrder !== undefined ? group.sortOrder : "");
    setEditedColor(group.color || "#ffffff");
    // 🔹 NEU: UVV Felder
    setEditedUvvTemplateType(group.uvvTemplateType || "");
    setEditedUvvStandardCode(group.uvvStandardCode || "");
  };

  const handleCancelEdit = () => {
    setEditingGroupId(null);
    setEditedName("");
    setEditedCategoryId("");
    setEditedProductGroupId("");
    setEditedSortOrder("");
    setEditedColor("");
    setEditedUvvTemplateType("");
    setEditedUvvStandardCode("");
  };

  // Aktualisieren
  const handleUpdateGroup = async (id) => {
    try {
      await api.put(`/product-groups/${id}`, {
        name: editedName,
        srrCategoryId: editedCategoryId,
        srrProductGroupId: editedProductGroupId,
        sortOrder: editedSortOrder ? parseInt(editedSortOrder, 10) : 0,
        color: editedColor || null,
        // 🔹 NEU: UVV Felder
        uvvTemplateType: editedUvvTemplateType || null,
        uvvStandardCode: editedUvvStandardCode || null,
      });
      setEditingGroupId(null);
      fetchProductGroups();
    } catch (error) {
      console.error("Fehler beim Aktualisieren der Produktgruppe:", error);
      alert("Fehler beim Aktualisieren: " + error.message);
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
      <div style={{ width: '1100px' }}>
        <Helmet>
          <title>Produktgruppen bearbeiten</title>
          <meta name="description" content="Produktgruppen bearbeiten" />
        </Helmet>

        <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Produktgruppen</h2>

        {/* Hinzufügen-Formular */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr 1.5fr 1.5fr auto',
            gap: '10px',
            marginBottom: '20px',
            alignItems: 'center'
          }}
        >
          <input
            type="text"
            value={newName}
            onChange={e => setNewName(e.target.value)}
            placeholder="Name"
            style={{ padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
          />
          <input
            type="text"
            value={newCategoryId}
            onChange={e => setNewCategoryId(e.target.value)}
            placeholder="srrCategoryId"
            style={{ padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
          />
          <input
            type="text"
            value={newProductGroupId}
            onChange={e => setNewProductGroupId(e.target.value)}
            placeholder="srrProductGroupId"
            style={{ padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
          />
          <input
            type="number"
            value={newSortOrder}
            onChange={e => setNewSortOrder(e.target.value)}
            placeholder="Reihenfolge"
            style={{ padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
          />
          <input
            type="color"
            value={newColor}
            onChange={e => setNewColor(e.target.value)}
            title="Farbe wählen"
            style={{ width: 40, height: 35, border: 'none', background: 'none' }}
          />
          {/* 🔹 NEU: UVV Template Type */}
          <select
            value={newUvvTemplateType}
            onChange={(e) => setNewUvvTemplateType(e.target.value)}
            style={{ padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
          >
            <option value="">UVV Template Typ</option>
            {UVV_TEMPLATE_TYPE_OPTIONS.map(o => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
          {/* 🔹 NEU: UVV Standard Code */}
          <select
            value={newUvvStandardCode}
            onChange={(e) => setNewUvvStandardCode(e.target.value)}
            style={{ padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
          >
            <option value="">UVV Norm</option>
            {UVV_STANDARD_CODE_OPTIONS.map(o => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>

          <button
            onClick={handleAddGroup}
            style={{
              padding: '6px 12px',
              background: '#28a745',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Hinzufügen
          </button>
        </div>

        {/* Liste */}
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {productGroups.map(group => (
            <li
              key={group.id}
              style={{
                display: 'grid',
                gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr 1.5fr 1.5fr auto',
                gap: '10px',
                alignItems: 'center',
                padding: '8px 0',
                borderBottom: '1px solid #ddd'
              }}
            >
              {editingGroupId === group.id ? (
                <>
                  <input
                    type="text"
                    value={editedName}
                    onChange={e => setEditedName(e.target.value)}
                    style={{ padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
                  />
                  <input
                    type="text"
                    value={editedCategoryId}
                    onChange={e => setEditedCategoryId(e.target.value)}
                    style={{ padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
                  />
                  <input
                    type="text"
                    value={editedProductGroupId}
                    onChange={e => setEditedProductGroupId(e.target.value)}
                    style={{ padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
                  />
                  <input
                    type="number"
                    value={editedSortOrder}
                    onChange={e => setEditedSortOrder(e.target.value)}
                    placeholder="Sort"
                    style={{ padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
                  />
                  <input
                    type="color"
                    value={editedColor}
                    onChange={e => setEditedColor(e.target.value)}
                    style={{ width: 32, height: 32, border: 'none', background: 'none' }}
                    title="Farbe wählen"
                  />
                  {/* 🔹 NEU: UVV Template Type */}
                  <select
                    value={editedUvvTemplateType}
                    onChange={(e) => setEditedUvvTemplateType(e.target.value)}
                    style={{ padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
                  >
                    <option value="">UVV Template Typ</option>
                    {UVV_TEMPLATE_TYPE_OPTIONS.map(o => (
                      <option key={o.value} value={o.value}>{o.label}</option>
                    ))}
                  </select>
                  {/* 🔹 NEU: UVV Standard Code */}
                  <select
                    value={editedUvvStandardCode}
                    onChange={(e) => setEditedUvvStandardCode(e.target.value)}
                    style={{ padding: '5px', borderRadius: '4px', border: '1px solid #ccc' }}
                  >
                    <option value="">UVV Norm</option>
                    {UVV_STANDARD_CODE_OPTIONS.map(o => (
                      <option key={o.value} value={o.value}>{o.label}</option>
                    ))}
                  </select>
                  <div>
                    <button onClick={() => handleUpdateGroup(group.id)} style={{ marginRight: '5px' }}>✅</button>
                    <button onClick={handleCancelEdit}>✖️</button>
                  </div>
                </>
              ) : (
                <>
                  {/* Farbfeld */}
                  <span
                    style={{
                      display: 'inline-block',
                      width: 18,
                      height: 18,
                      borderRadius: '4px',
                      background: group.color || '#eee',
                      border: '1px solid #aaa',
                      verticalAlign: 'middle'
                    }}
                    title={group.color}
                  />
                  <span>{group.name}</span>
                  <span>{group.srrCategoryId}</span>
                  <span>{group.srrProductGroupId}</span>
                  <span>{group.sortOrder}</span>
                  {/* 🔹 Anzeige UVV */}
                  <span title="UVV Template Typ">{group.uvvTemplateType || '—'}</span>
                  <span title="UVV Norm">{group.uvvStandardCode || '—'}</span>

                  <div>
                    <button
                      onClick={() => handleEditGroup(group)}
                      style={{
                        fontSize: '15px',
                        padding: '5px 10px',
                        background: '#007bff',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        marginRight: '5px',
                      }}
                    >
                      Bearbeiten
                    </button>
                    <button
                      onClick={() => handleDeleteGroup(group.id)}
                      style={{
                        fontSize: '15px',
                        padding: '5px 10px',
                        background: '#dc3545',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer'
                      }}
                    >
                      Löschen
                    </button>
                  </div>
                </>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ProductGroupList;
